// Sun Valley : page Boutiques (sections/sv-boutiques.liquid). Recherche par code postal ou position,
// tri par distance, bascule liste / carte (Leaflet chargé à la demande depuis les assets du thème,
// fond de carte OpenStreetMap), horaires du jour. Le code postal est partagé avec la fiche produit.
(() => {
  // Textes traduits (snippets/sv-textes-js.liquid) ; à défaut, la clé
  const T = (cle, v) => (window.svT ? window.svT(cle, v) : cle);
  const CLE = 'sv_cp';
  const lire = () => { try { return localStorage.getItem(CLE) || ''; } catch (e) { return ''; } };
  const retenir = (v) => { try { localStorage.setItem(CLE, v); } catch (e) { /* stockage indisponible */ } };
  const distance = (a, b) => {
    const r = 6371, dLat = (b.lat - a.lat) * Math.PI / 180, dLng = (b.lng - a.lng) * Math.PI / 180;
    const x = Math.sin(dLat / 2) ** 2 + Math.cos(a.lat * Math.PI / 180) * Math.cos(b.lat * Math.PI / 180) * Math.sin(dLng / 2) ** 2;
    return 2 * r * Math.asin(Math.sqrt(x));
  };
  const km = (d) => d < 1 ? T('commun.km_moins_1') : d < 10 ? `${d.toFixed(1).replace('.', T('commun.separateur_decimal'))} km` : `${Math.round(d)} km`;
  // Noms des jours tels qu'écrits dans les horaires du métaobjet (donnée en français) : ne pas traduire
  const JOURS = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'];

  async function geocoder(cp) {
    const r = await fetch(`https://api-adresse.data.gouv.fr/search/?q=${encodeURIComponent(cp)}&type=municipality&postcode=${encodeURIComponent(cp)}&limit=1`);
    const j = await r.json();
    const f = j.features && j.features[0];
    return f ? { lat: f.geometry.coordinates[1], lng: f.geometry.coordinates[0] } : null;
  }

  if (customElements.get('sv-boutiques')) return;
  customElements.define('sv-boutiques', class extends HTMLElement {
    connectedCallback() {
      this.liste = this.querySelector('.sv-boutiques__liste');
      this.items = [...this.liste.querySelectorAll('.sv-boutiques__item')];
      this.form = this.querySelector('.sv-boutiques__recherche');
      this.cp = this.querySelector('.sv-boutiques__cp');
      this.message = this.querySelector('.sv-boutiques__message');
      this.carteConteneur = this.querySelector('.sv-boutiques__carte');
      this.boutons = [...this.querySelectorAll('.sv-boutiques__bascule button')];
      this.position = null;
      this.carte = null;
      this.marqueurs = {};

      this.items.forEach((li) => this.horairesDuJour(li));
      this.form.addEventListener('submit', (e) => { e.preventDefault(); this.chercher(this.cp.value.trim()); });
      this.querySelector('.sv-boutiques__geo').addEventListener('click', () => this.geolocaliser());
      this.boutons.forEach((b) => b.addEventListener('click', () => this.basculer(b.dataset.vue)));
      const memo = lire();
      if (memo) { this.cp.value = memo; this.chercher(memo, true); }
    }

    horairesDuJour(li) {
      const brut = li.dataset.horaires || '';
      if (!brut) return;
      const jour = JOURS[new Date().getDay()];
      const ligne = brut.split('\n').find((l) => l.toLowerCase().startsWith(jour.toLowerCase()));
      const cible = li.querySelector('.sv-boutiques__aujourdhui');
      if (!cible || !ligne) return;
      const valeur = ligne.split(':').slice(1).join(':').trim();
      const ferme = /ferm/i.test(valeur);
      cible.textContent = ferme ? T('boutiques.ferme_aujourdhui') : T('boutiques.aujourdhui', { horaires: valeur });
      cible.classList.toggle('is-fermee', ferme);
    }

    dire(texte) { this.message.textContent = texte; this.message.hidden = !texte; }

    async chercher(cp, silencieux) {
      if (!/^\d{5}$/.test(cp)) { if (!silencieux) this.dire(T('commun.cp_invalide')); return; }
      this.dire('');
      try {
        const p = await geocoder(cp);
        if (!p) { this.dire(T('commun.cp_introuvable')); return; }
        retenir(cp); this.position = p; this.trier();
      } catch (e) { this.dire(T('boutiques.recherche_indisponible')); }
    }

    geolocaliser() {
      if (!navigator.geolocation) { this.dire(T('boutiques.position_indisponible')); return; }
      navigator.geolocation.getCurrentPosition(
        (pos) => { this.position = { lat: pos.coords.latitude, lng: pos.coords.longitude }; this.cp.value = ''; this.dire(''); this.trier(); },
        () => this.dire(T('boutiques.position_refusee')),
        { timeout: 8000 }
      );
    }

    trier() {
      const p = this.position;
      const avec = this.items.map((li) => {
        const lat = parseFloat(li.dataset.lat), lng = parseFloat(li.dataset.lng);
        const d = (lat && lng) ? distance(p, { lat, lng }) : Infinity;
        const cible = li.querySelector('.sv-boutiques__distance');
        if (cible) cible.textContent = isFinite(d) ? km(d) : '';
        return { li, d };
      }).sort((a, b) => a.d - b.d);
      avec.forEach(({ li }, i) => { this.liste.appendChild(li); li.classList.toggle('is-proche', i === 0); });
      if (this.carte && isFinite(avec[0].d)) this.carte.setView([p.lat, p.lng], 9);
    }

    basculer(vue) {
      this.boutons.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.vue === vue)));
      const carte = vue === 'carte';
      this.carteConteneur.hidden = !carte;
      this.liste.hidden = carte;
      if (carte) this.ouvrirCarte();
    }

    async ouvrirCarte() {
      if (this.carte) { this.carte.invalidateSize(); return; }
      if (!window.L) {
        await new Promise((ok, ko) => { const s = document.createElement('script'); s.src = this.dataset.leaflet; s.onload = ok; s.onerror = ko; document.head.appendChild(s); });
      }
      const L = window.L;
      const zone = this.carteConteneur.querySelector('.sv-boutiques__map');
      this.carte = L.map(zone, { scrollWheelZoom: false });
      L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 18, attribution: '&copy; OpenStreetMap' }).addTo(this.carte);
      const icone = L.divIcon({ className: 'sv-boutiques__marqueur', html: '<span></span>', iconSize: [22, 22], iconAnchor: [11, 22] });
      const points = [];
      this.items.forEach((li) => {
        const lat = parseFloat(li.dataset.lat), lng = parseFloat(li.dataset.lng);
        if (!lat || !lng) return;
        points.push([lat, lng]);
        const m = L.marker([lat, lng], { icon: icone }).addTo(this.carte);
        m.bindPopup(`<strong>${li.dataset.nom}</strong><br>${li.dataset.ville}<br><a href="${li.dataset.itineraire}" target="_blank" rel="noopener">${T('boutiques.itineraire')}</a>`);
        m.on('click', () => { this.items.forEach((x) => x.classList.remove('is-proche')); li.classList.add('is-proche'); });
        this.marqueurs[li.dataset.handle] = m;
      });
      if (this.position) this.carte.setView([this.position.lat, this.position.lng], 9);
      else if (points.length) this.carte.fitBounds(points, { padding: [24, 24] });
    }
  });
})();
